import * as yup from 'yup';

import { FORM_KEYS } from 'shared/constant';

const { AGREEMENT } = FORM_KEYS;

const contractSchema = (intl, isMUT) => yup.object().shape({
  [AGREEMENT.NDPF]: yup
    .boolean()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [AGREEMENT.PROPOSED_PLAN]: yup
    .boolean()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      () => {
        if (isMUT) return false;
        return true;
      },
    ),
  // .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [AGREEMENT.NDPF_PROPOSED_PLAN_SIGNATURE]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
});

export default contractSchema;
